// src/utils/crearNotificacion.js

import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";

export const crearNotificacion = async ({
  titulo,
  mensaje,
  tipo,
  emp_id,
  para,
  link = "",
  data = {},
}) => {
  return await addDoc(collection(db, "notificaciones"), {
    titulo,
    mensaje,
    tipo,
    emp_id,
    para,
    leidoPor: [],
    link,
    data,
    createdAt: serverTimestamp(),
  });
};